export const SERVER_URL = '';
export default SERVER_URL;
